import React from 'react'
import { Switch } from 'react-router-dom'
import List from 'app-support/productgroup/components/List'
import Tree from 'app-support/productgroup/components/Tree'
import MainGroup from 'app-support/productgroup/components/MainGroup'
import EditSubgroup from 'app-support/productgroup/components/SubGroup/Edit'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_PRODUCT_GROUPS } from 'app-support/permissions/Permissions'
import {
  mainProductGroupRouteEdit,
  productGroupRoute,
  productGroupRouteList,
  productGroupRouteTree,
  subProductGroupRouteEdit
} from 'routes/routeNames'

const enhance = withRegionSwitchHandler(productGroupRoute)

class ProductGroupRoutes extends React.Component {
  render() {
    return (
      <Switch>
        <PermissionRoute permission={PERMISSION_MANAGE_PRODUCT_GROUPS} exact path={productGroupRouteList} component={List} />
        <PermissionRoute permission={PERMISSION_MANAGE_PRODUCT_GROUPS} path={subProductGroupRouteEdit} component={EditSubgroup} />
        <PermissionRoute permission={PERMISSION_MANAGE_PRODUCT_GROUPS} path={mainProductGroupRouteEdit} component={MainGroup} />
        <PermissionRoute permission={PERMISSION_MANAGE_PRODUCT_GROUPS} path={productGroupRouteTree} component={Tree} />
        <PermissionRoute permission={PERMISSION_MANAGE_PRODUCT_GROUPS} path={productGroupRoute} component={List} />
      </Switch>
    )
  }
}

export default enhance(ProductGroupRoutes)
